// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#people-page .top-banner{background-color:#e8e8e8;text-transform:uppercase}#people-page .toggle-button{background-color:#fff;border:1px solid #ccc;border-radius:4px;color:#000;box-shadow:0 0 2px rgba(0,0,0,0.13)}\n", ""]);
